import { create } from "zustand";

export const unreadNotifications = create((set) => ({
  count: 0,

  setCount: (data) => {
    set(() => ({ count: data }));
  },
}));
